import {
  Dialog,
  Card,
  CardContent,
  Typography,
  Divider,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BaseDialogProps } from './types';
import { CertaraLogo } from '../../assets/icons';

export interface BaseInformationDialogProps extends BaseDialogProps {
  /** Application name (e.g., "Load", "Security") */
  appName: string;
  
  /** Application version */
  version: string;
  
  /** Copyright text (optional, defaults to current year) */
  copyright?: string;
}

export function BaseInformationDialog({
  open,
  onClose,
  appName,
  version,
  copyright,
  maxWidth = 'sm',
  DialogProps: additionalDialogProps,
}: BaseInformationDialogProps) {
  const { t } = useTranslation('common');
  const currentYear = new Date().getFullYear();
  const copyrightText = copyright || t('informationDialog.defaultCopyright', { year: currentYear });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      {...additionalDialogProps}
      PaperProps={{
        sx: { 
          backgroundColor: 'transparent',
          boxShadow: 'none',
          ...additionalDialogProps?.PaperProps?.sx 
        }
      }}
    >
      <Card 
        sx={{ 
          backgroundColor: '#f5f5f5',
          padding: '10px',
          maxWidth: '525px',
          maxHeight: '350px',
        }}
      >
        <CardContent>
          {/* Certara Logo */}
          <Box 
            sx={{ 
              display: 'flex', 
              justifyContent: 'center',
              marginTop: '10px',
              marginBottom: '20px',
            }}
          >
            <CertaraLogo size={180} style={{ maxWidth: '67%', height: 'auto' }} />
          </Box>

          {/* Version Title */}
          <Typography 
            variant="h6" 
            sx={{ 
              textAlign: 'center',
              marginBottom: '16px',
            }}
          >
            {t('informationDialog.versionTitle', { appName, version })}
          </Typography>

          <Divider />

          {/* Copyright */}
          <Typography 
            variant="body2" 
            sx={{ 
              textAlign: 'center',
              marginTop: '24px',
            }}
          >
            {copyrightText}
          </Typography>
        </CardContent>
      </Card>
    </Dialog>
  );
}
